/* eslint-disable import/no-extraneous-dependencies */
import 'react-perfect-scrollbar/dist/css/styles.css';
import { HelmetProvider } from 'react-helmet-async';
import { useRoutes, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import GlobalStyles from './components/GlobalStyles';
import theme from './theme';
import routes from './routes';
import HelmetSeo from './components/HelmetSeo';

import 'react-toastify/dist/ReactToastify.css';

const helmetContext = {};

function App() {
  // const content = useRoutes(routes);
  const appRoutes = createBrowserRouter(routes);

  return (
    <HelmetProvider context={helmetContext}>
      <HelmetSeo
        title="Rewot Ciro | Dashboard"
        name="Rewot Ciro"
        type="website"
        description="Check out the new app of Rewot Ciro when looking for a secure, fast, and simple way to purchase goods on credit."
      />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <RouterProvider router={appRoutes} />
          <ToastContainer />
        </ThemeProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );
}

export default App;
